import config from '@/config.js';
import {datePassed} from "@/util";

export default (app) => {
    return {
        namespaced: true,

        state: () => ({
            subscriptionPlans: [],
        }),

        getters: {
            subscriptionPlans: (state) => state.subscriptionPlans,
            expired: (state) => {
                const store = app.config.globalProperties.$store;
                const currentUser = store.getters['auth/user'];
                const subscription = currentUser?.subscription;

                return store.getters['isCustomer'] && (
                    store.getters['chat/messageLimitExceeded']
                    || datePassed(subscription.end_date)
                    || subscription.status === 'expired'
                );
            },
            canCallWithAudio: state => {
                const store = app.config.globalProperties.$store;

                if (!store.getters['isCustomer']) {
                    return true;
                }

                const currentUser = store.getters['auth/user'];
                const subscription = currentUser?.subscription;

                return subscription.plan.features.findIndex(e => e.name === 'chat_audio_call') >= 0;
            },
            canCallWithVideo: state => {
                const store = app.config.globalProperties.$store;

                if (!store.getters['isCustomer']) {
                    return true;
                }

                const currentUser = store.getters['auth/user'];
                const subscription = currentUser?.subscription;

                return subscription.plan.features.findIndex(e => e.name === 'chat_video_call') >= 0;
            },
        },

        mutations: {
            setSubscriptionPlans(state, data) {
                state.subscriptionPlans = data;
            },
        },

        actions: {
            async upgrade({state, rootState}, plan_id) {
                const r = await window.http.post(`${config.API_URL}/users/${rootState.auth.authUser.id}/subscription/upgrade`, {plan_id});

                if (r.success) {
                    rootState.auth.authUser.subscription.plan = state.subscriptionPlans.find(e => e.id === plan_id);
                }

                return r;
            },

            async extend({state, rootState}, plan_id) {
                const r = await window.http.post(`${config.API_URL}/users/${rootState.auth.authUser.id}/subscription/extend`, {plan_id});

                if (r.success) {
                    rootState.auth.authUser.subscription.plan = state.subscriptionPlans.find(e => e.id === plan_id);
                }

                return r;
            },

            async getSubscriptionPlans({commit}, plan_id) {
                const r = await window.http.get(`${config.API_URL}/subscription-plans`);

                if (r.success) {
                    commit('setSubscriptionPlans', r.data);
                }

                return r;
            },

            async check({}, {transaction_id, checkout_id}) {
                return await window.http.post(`${config.API_URL}/subscription-check`, {transaction_id, checkout_id});
            },
        }
    };
};
